import {Data} from 'charts/BarChart/data';
import * as d3 from 'd3';
import {Configurator} from 'utils/makeConfigurator';

export function makeTestData(conf: Configurator): Data {
  const random = d3.randomLcg(conf('seed', 1));
  const palette = [
    '#FFB9AF',
    '#285ADB',
    '#FC3F1D',
    '#33903D',
    '#99EB89',
    '#FFBF44',
    '#43331A',
    '#50EBD8',
    '#B07AFE',
    '#E5E5E5',
  ];
  const centuriesLabels = ['XII', 'XIII', 'XIV', 'XV', 'XVI', 'XVII', 'XVIII', 'XIX', 'XX', 'XXI'];
  const randomRectCount = d3.randomInt.source(random)(
    conf('rectsCount.min', palette.length),
    conf('rectsCount', palette.length) + 1,
  );
  return {
    stacks: d3.range(conf('stacksCount', 10)).map(stackNo => ({
      label: centuriesLabels[stackNo] ?? `#${stackNo.toString()}`,
      rects: d3.range(randomRectCount()).map(rectNo => ({
        value: random() * 1500,
        color: palette[rectNo % palette.length],
      })),
    })),
  };
}
